import * as React from "react";
import { Box, Container } from "@mui/material";
import { ProductSection } from "./ProductSection";
import HomeLandingVideo from "../../../Assets/Home_Landing_video.mp4";


function MainContent() {
  return (
    <Box
      component="main"
      sx={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        backgroundColor: "#130D35",
      }}
    >
      {/* Background Video */}
      <Box
        component="video"
        autoPlay
        loop
        muted
        playsInline
        src={HomeLandingVideo}
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
          zIndex: 0,
        }}
      />

      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(19, 13, 53, 0.75)",
          zIndex: 1,
        }}
      />

      {/* Foreground Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          px: 2,
        }}
      >
        {/* Optional: Use Container to limit width */}
        <Container
  maxWidth="lg"
  sx={{
    display: "flex",
    justifyContent: "center",  // Ensure horizontal centering
    px: 2,
    margin: "0 auto",  // To center the content
  }}
>
  <ProductSection />
</Container>


      </Box>
    </Box>
  );
}

export default MainContent;
